/**
 * Swaps a reel's poster for the real video on the first tap.
 *
 * Loading four vertical videos up front costs several megabytes before anyone
 * has asked to watch one, which is the wrong trade on a mid-range phone. The
 * markup ships a poster plus a <template>; this moves the template's contents
 * into the frame when the play button is pressed.
 */
class ProductReel extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-reel-play]');
    if (!this.button) return;
    this.button.addEventListener('click', this.load.bind(this), { once: true });
  }

  load() {
    const template = this.querySelector('[data-reel-video]');
    const frame = this.querySelector('.product-reels__frame');
    if (!template || !frame) return;

    frame.appendChild(template.content.cloneNode(true));
    template.remove();
    this.button.remove();

    const video = frame.querySelector('video');
    if (video) {
      video.play().catch(() => {
        /* Autoplay can be refused; the controls are visible either way. */
      });
    }
  }
}

if (!customElements.get('product-reel')) {
  customElements.define('product-reel', ProductReel);
}
